import { postJSON } from 'api/fetch';

type IncrementType = {
  metricName: string;
  tags?: string[];
};

export const sendIncrementMetric = ({ metricName, tags }: IncrementType) =>
  postJSON('/metrics/increment', { metric_name: metricName, tags });
